import React from 'react';
import gql from 'graphql-tag';
import { useParams } from 'react-router-dom';
import BillOfQuantityTable from '../../components/BillOfQuantity/BllOfQuantityTable';
import PageWrapper from '../../components/PageWrapper';
import { useQuery } from 'react-apollo';
import { OfferProjectCatalog, OfferProjectCatalogVariables } from './types/OfferProjectCatalog';
import { BillOfQuantityEntityType } from '../../types/graphql';

const PROJECT_CATALOG_QUERY = gql`
  query OfferProjectCatalog($projectNumber: String!) {
    project(where: { projectNumber: $projectNumber }) {
      id
      projectNumber
      catalog {
        id
      }
    }
  }
`;

interface IUrlParams {
  projectNumber: string;
}

const Offer: React.FC = () => {
  const { projectNumber } = useParams<IUrlParams>();

  const { data, error, loading } = useQuery<OfferProjectCatalog, OfferProjectCatalogVariables>(
    PROJECT_CATALOG_QUERY,
    { variables: { projectNumber } },
  );

  if (loading) {
    return null;
  }
  if (!data) {
    console.log('no data');
    return null;
  }
  if (error) {
    console.log(error);
    return null;
  }

  return (
    <PageWrapper>
      <BillOfQuantityTable entityType={BillOfQuantityEntityType.OFFER} project={data.project} />
    </PageWrapper>
  );
};

export default Offer;
